import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import { deleteProduct } from '../api/products';
import { customConfirm } from '../utils/utils';
import { getImageUrl } from '../api';
import { Button } from './Button';
import S from './ProductItem.styl';
var ProductItem = /** @class */ (function (_super) {
    __extends(ProductItem, _super);
    function ProductItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
        };
        _this.deleteItem = function () {
            var i18n = _this.props.store.i18n;
            var product = _this.props.product;
            if (product) {
                customConfirm(i18n.productsDeleteSummary, _this.props.store, function (success) {
                    if (success) {
                        _this.setState({ loading: true });
                        var request = {
                            id: product.id,
                        };
                        deleteProduct(request).then(function () {
                            _this.setState({ loading: false });
                            _this.isUpdated();
                        }).catch(function (error) {
                            _this.setState({ loading: false });
                            alert(error);
                        });
                    }
                });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.isEditClicked = function () {
            if (_this.props.isEditClicked) {
                _this.props.isEditClicked(_this.props.product);
            }
        };
        return _this;
    }
    ProductItem.prototype.componentDidMount = function () {
        // Did Mount
    };
    ProductItem.prototype.render = function () {
        var props = this.props;
        var product = props.product;
        var i18n = props.store.i18n;
        return (React.createElement("div", { className: S.productItem }, product ?
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: S.tableCell + " idCell" }, product.id),
                React.createElement("div", { className: S.tableCell + " imageCell" },
                    React.createElement("img", { src: getImageUrl(product.image || '') })),
                React.createElement("div", { className: S.tableCell }, product.title),
                React.createElement("div", { className: S.action },
                    React.createElement(Button, { className: S.updateButton, type: "button", onClick: this.isEditClicked }, i18n.actionUpdate),
                    React.createElement(Button, { className: S.deleteButton, type: "button", onClick: this.deleteItem }, i18n.actionDelete)))
            :
                React.createElement(React.Fragment, null)));
    };
    ProductItem = __decorate([
        inject('store'),
        observer
    ], ProductItem);
    return ProductItem;
}(React.Component));
export { ProductItem };
